import { BottomNavigation, BottomNavigationAction, Box, Typography } from "@mui/material"
import { JSX } from "react"
import { useLocation, useNavigate, useParams } from "react-router"
import { getFormattedVersion } from "utils/version"

export const Footer = (): JSX.Element => {
  const { projectID, examinationID } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  // Determine the current active tab based on the current path
  const getCurrentValue = () => {
    if (location.pathname.includes("/audit_trail")) {
      return 3
    } else if (location.pathname.includes("/tasks")) {
      return 2
    } else if (location.pathname.includes("/examination/")) {
      return 1
    }
    return 0
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate(`/dashboard`)
        break
      case 1:
        navigate(`/examination/${projectID}/${examinationID}`)
        break
      case 2:
        navigate(`/examination/${projectID}/${examinationID}/tasks`)
        break
      default:
        navigate(`/examination/${projectID}/${examinationID}/audit_trail`)
        break
    }
  }

  return (
    <Box>
      <BottomNavigation showLabels value={getCurrentValue()} onChange={handleChange}>
        <BottomNavigationAction label="Dashboard" />
        <BottomNavigationAction label="Prüfung" />
        <BottomNavigationAction label="Arbeitsgänge" />
        <BottomNavigationAction label="AuditTrail" />
      </BottomNavigation>

      {/* Version display for bug reporting */}
      <Box
        sx={{
          textAlign: "center",
          py: 0.5,
          backgroundColor: "background.paper",
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
          {getFormattedVersion()}
        </Typography>
      </Box>
    </Box>
  )
}
